import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaExclamationTriangle,
    FaHeartbeat,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import SecurityChartsContainer from '../Common/SecurityChartsContainer';
import OcurrencesWrapper from './Ocurrences';
import RankingsWrapper from './Rankings ';
import VehiclesWrapper from './VehiclesList';
import SpotsWrapper from './Spots';
import DetailsWrapper from './Details';

const Vehicles = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate(`/governanceroom/${props.dashboardPath}`);
    };

    const menus = [ 
        {
            title: 'Mapeamento',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/spots`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Ocorrências',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/ocurrences`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Rankings',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/rankings`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Veiculos',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/vehicles`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Detalhamento',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/details`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },

      
    ];
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/spots`]:'Mapeamento',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/ocurrences`]:'Resultados Gerais das Ocorrências',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/rankings`]:'Rankings',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/vehicles`]:'Veículos',
        ['/governanceroom/${props.dashboardPath}/${props.menuPath}/details']:'Detalhamento',
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <SecurityChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="spots" replace />}
                        />
                        <Route
                            path="ocurrences"
                            element={<OcurrencesWrapper />}
                        />
                        <Route
                            path="rankings"
                            element={<RankingsWrapper />}
                        />
                        <Route
                            path="vehicles"
                            element={<VehiclesWrapper />}
                        />
                        <Route
                            path="spots"
                            element={<SpotsWrapper />}
                        />
                        <Route
                            path="details"
                            element={<DetailsWrapper />}
                        />
                    </Routes>
                </SecurityChartsContainer>
            </Box>
        </Box>
    );
};

export default Vehicles;
